import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { Page } from './pages';

@Component({
  selector: 'mojo-nav-left',
  templateUrl: './nav-left.component.html',
  styleUrls: ['./nav-left.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavLeftComponent implements OnInit, OnDestroy {
  @Input()
  pages: Page[];

  private sub: Subscription = new Subscription();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cdf: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.sub.add(
      this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.cdf.detectChanges())
    );
  }

  getUrlRouteString() {
    const urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams = {};
    return urlTree.toString().split('/');
  }

  getPageRoutePart(pageRoute) {
    const pageRouteArray = pageRoute.toString().split('/');
    return pageRouteArray[pageRouteArray.length - 1];
  }

  checkActiveCondition(pageRoute) {
    const currentRoute = this.getUrlRouteString();
    return this.getPageRoutePart(pageRoute) === currentRoute[currentRoute.length - 1];
  }

  redirect(pageRoute, queryParams) {
    const currentRoute = this.getUrlRouteString();
    if ((this.getPageRoutePart(pageRoute) === currentRoute[currentRoute.length - 1])) {
      queryParams = this.route.snapshot.queryParams;
    }

    this.router.navigate([pageRoute],
      { relativeTo: this.route, queryParams });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
